// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"418":"bf126d60","668":"be0caacc"}[chunkId] + ".js";
};